import React from 'react';
import ProfileWizard from '../components/profile/ProfileWizard';

const StartupProfilePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-dark-950">
      <ProfileWizard userType="startup" />
    </div>
  );
};

export default StartupProfilePage;
